import { ExoticsCol } from "../../../Helpers/columns";
interface IProviderPoolTabProps {
  exoticTableData: any;
}
export default function ToteExostic({
  exoticTableData,
}: IProviderPoolTabProps) {
  const cellTemplate = (
    poolType: any,
    field: string,
    _exoticTableData: any
  ) => {
    switch (field) {
      case "poolType":
        return (
          <div>
            {_exoticTableData[poolType]?.poolStatus === "OPEN" ? (
              <i className="fa fa-eye text-success"></i>
            ) : (
              <i className="fa fa-eye text-danger"></i>
            )}{" "}
            &nbsp;&nbsp;
            {poolType}
          </div>
        );
      case "totalInvestment":
        return _exoticTableData[poolType].totalInvestment
          ? _exoticTableData[poolType].totalInvestment  .toFixed(2)
          : 0;
      case "totalLayoffInv":
        return _exoticTableData[poolType].totalLayoffInv
          ? _exoticTableData[poolType].totalLayoffInv.toFixed(2)
          : 0;
      case "totalPayoff":
        return _exoticTableData[poolType].totalPayoff
          ? _exoticTableData[poolType].totalPayoff.toFixed(2)
          : 0;
    }
  };
  return (
    <div className="p-2">
      <table className="pz-table" style={{borderRadius:"0.6"}}>
        <thead>
          <tr>
            {ExoticsCol.map((col) => {
              return (
                <th key={col.field} data-placement="right">
                  {col.header}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody style={{ background: "#404040" }}>
          {exoticTableData &&
            Object.keys(exoticTableData).map((poolType: any, index: number) => {
              return (
                <tr className="row-t" key={index}>
                  {ExoticsCol.map((col) => {
                    return (
                      <td key={col.field}>
                        {cellTemplate(poolType, col.field, exoticTableData)}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}
